import React, { useState, useEffect } from 'react';
import { Typography, Paper, Alert, Chip, Tooltip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { directConnectAPI } from '../services/api';

const errText = (err, fallback) => err.response?.data?.detail || fallback;

// A customer's AWS Direct Connect links and their virtual interfaces (BGP). Shown only for customers that have one.
function DirectConnectPanel({ customerCode }) {
  const [links, setLinks] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let current = true;
    setLinks(null); setError(null);
    directConnectAPI.get(customerCode)
      .then((res) => { if (current) setLinks(res.data.connections); })
      .catch((err) => { if (current) setError(errText(err, 'Could not load Direct Connect status')); });
    return () => { current = false; };
  }, [customerCode]);

  if (error) return <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>;
  if (!links || links.length === 0) return null;

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>Direct Connect</Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Link</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Speed</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Virtual interfaces</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {links.map((c) => (
              <TableRow key={c.id} hover>
                <TableCell><Typography variant="body2" fontWeight="bold">{c.name}</Typography><Typography variant="caption" color="text.secondary">{c.id}</Typography></TableCell>
                <TableCell>{c.location}{c.site ? ` (${c.site})` : ''}</TableCell>
                <TableCell>{c.bandwidth}</TableCell>
                <TableCell><Chip size="small" color={c.status === 'up' ? 'success' : 'error'} label={c.status === 'up' ? 'Up' : `Down (${c.state})`} /></TableCell>
                <TableCell>
                  {c.vifs.length === 0 && '-'}
                  {c.vifs.map((v) => (
                    <Tooltip key={v.id} title={`${v.id} - ${v.type || ''} interface ${v.state}, BGP ${v.bgp}`}>
                      <Chip size="small" sx={{ mr: 0.5 }} variant={v.state === 'available' && v.bgp !== 'down' ? 'filled' : 'outlined'}
                        color={v.state === 'available' && v.bgp !== 'down' ? 'success' : 'error'} label={`${v.name}: BGP ${v.bgp}`} />
                    </Tooltip>
                  ))}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default DirectConnectPanel;
